import React, { useState } from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Box } from "@mui/material";
import Active from "./Active";
import Unused from "./Unused";
import Cancel from "./Cancel";
import Free from "./Free";
const Subscriptions = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabItems = [
    { label: "Free", value: "1" },
    { label: "Active", value: "2" },
    { label: "Unused", value: "3" },
    { label: "Cancelled", value: "4" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        paddingBottom: "30px",
      }}
    >
      {/* Tabs Wrapper with Horizontal Scroll on Small Screens */}

      <Box
        sx={{
          borderColor: "divider",
          width: {
            xs: "55%",
            sm: "25%",
          },
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="Subscription Tabs"
          TabIndicatorProps={{
            sx: {
              display: "none",
            },
          }}
          sx={{
            "& .MuiTab-root": {
              minWidth: "auto",
              px: 0.5,
              fontSize: {
                xs: "0.65rem",
                sm: "1rem",
              },
            },
          }}
        >
          {tabItems.map((tab) => (
            <Tab
              key={tab.value}
              label={
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    cursor: "pointer",
                  }}
                >
                  {tab.label}
                  {value === tab.value && (
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        bottom: -4,
                        height: 2,
                        width: "105%",
                        backgroundColor: "#1976d2",
                        borderRadius: 1,
                      }}
                    />
                  )}
                </label>
              }
              value={tab.value}
            />
          ))}
        </Tabs>
      </Box>

      {/* Conditional Rendering Based on Tab Selection */}
      {value === "1" && <Free />}
      {value === "2" && <Active />}
      {value === "3" && <Unused />}
      {value === "4" && <Cancel />}
    </Box>
  );
};

export default Subscriptions;

// const Subscriptions = () => {
//   const [value, setValue] = useState("1");
//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   const [tabsValue, setTabsValue] = useState(1);

//   const tabItems = [
//     { label: "Free", value: "1" },
//     { label: "Active", value: "2" },
//     { label: "Unused", value: "3" },
//     { label: "Cancelled", value: "4" },
//   ];

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         width: "100%",
//         paddingBottom: "30px",
//       }}
//     >
//       {/* Tabs Wrapper with Horizontal Scroll on Small Screens */}

//       <Box
//         sx={{
//           borderColor: "divider",
//           width: {
//             xs: "55%",
//             sm: "25%",
//           },
//         }}
//       >
//         <Tabs
//           value={value}
//           onChange={handleChange}
//           variant="fullWidth"
//           aria-label="Subscription Tabs"
//           TabIndicatorProps={{
//             sx: {
//               display: "none",
//             },
//           }}
//           sx={{
//             "& .MuiTab-root": {
//               minWidth: "auto",
//               px: 0.5,
//               fontSize: {
//                 xs: "0.65rem",
//                 sm: "1rem",
//               },
//             },
//           }}
//         >
//           {tabItems.map((tab, index) => (
//             <Tab
//               onClick={() => setTabsValue(tab.value)}
//               key={tab.value}
//               label={
//                 <label
//                   style={{
//                     position: "relative",
//                     display: "inline-block",
//                     cursor: "pointer",
//                   }}
//                 >
//                   {tab.label}
//                   {tabsValue === tab.value && (
//                     <span
//                       style={{
//                         position: "absolute",
//                         left: 0,
//                         bottom: -4,
//                         height: 2,
//                         width: "105%",
//                         backgroundColor: "#1976d2",
//                         borderRadius: 1,
//                       }}
//                     />
//                   )}
//                 </label>
//               }
//               value={tab.value}
//             />
//           ))}
//         </Tabs>
//       </Box>

//       {/* Conditional Rendering Based on Tab Selection */}
//       {value === "1" && <Free />}
//       {value === "2" && <Active />}
//       {value === "3" && <Unused />}
//       {value === "4" && <Cancel />}
//     </Box>
//   );
// };

// export default Subscriptions;
